import React, { PropsWithChildren } from 'react';

import './NoPrint.css';

export default function NoPrint({
  children,
}: PropsWithChildren<Record<never, never>>) {
  return <div className="NoPrint">{children}</div>;
}
